import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { BaseButton } from '@7f-ui/components/button/button';
import type { PropsWithChildren } from 'react';
export type ImageButtonProps = PropsWithChildren<{
  className?: string;
  onClick?: () => void;
}>;
export function ImageButton(t0) {
  const $ = _c(6);
  const {
    children,
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("relative transition-filter duration-100 hover:brightness-110 active:brightness-125", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== onClick || $[4] !== t1) {
    t2 = <BaseButton className={t1} onClick={onClick}>{children}</BaseButton>;
    $[2] = children;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}